module.exports = __webpack_public_path__ + "static/media/shop.e24b24cb.jpg";